angular.module('GlobalHelpersModule').filter "orProviderDidNotAsk", ->
  (value) ->
    if value && (value.length > 0 || parseInt(value) != 0)
      value
    else
      'Provider did not ask'